import React from "react";

import logo from "images/logo.jpg";

import { gallery } from "gallery.js";

const Footer = () => {
	const imagesFooter = [...gallery];

	return (
		<>
			<div className="rts-footer-one footer-bg-one mt--160 pb--85">
				<div className="container">
					<div className="row g-0 bg-cta-footer-one">
						<div className="col-lg-12">
							<div className="bg-cta-footer-one wrapper">
								<div className="row align-items-center">
									<div className="col-lg-3 col-md-6 col-sm-6 col-12">
										<a href="/" className="logo-area-footer">
											<img
												src={logo}
												alt="Logo TecnoCGE - Specialisti in cartongesso a Codogno, Lodi, Piacenza"
											/>
										</a>
									</div>
									<div className="col-lg-3 col-md-6 col-sm-6 col-12">
										<div className="single-cta-area">
											<div className="icon">
												<i className="fa-solid fa-phone"></i>
											</div>
											<div className="contact-info">
												<p>Telefono</p>
												<a href="tel:+393356197378">335 61 97 378</a>
											</div>
										</div>
									</div>
									<div className="col-lg-3 col-md-6 col-sm-6 col-12">
										<div className="single-cta-area">
											<div className="icon">
												<i className="fa-solid fa-envelope"></i>
											</div>
											<div className="contact-info">
												<p>Email</p>
												<a href="mailto:tecnocge@gmail.com">tecnocge@gmail.com</a>
											</div>
										</div>
									</div>
									<div className="col-lg-3 col-md-6 col-sm-6 col-12">
										<div className="single-cta-area last">
											<div className="icon">
												<i className="fa-regular fa-location-dot"></i>
											</div>
											<div className="contact-info">
												<p>Indirizzo</p>
												<a
													href="https://www.google.it/maps/place/Via+Sergio+Ramelli,+5,+26845+Codogno+LO/@45.1651038,9.6880444,17z/data=!3m1!4b1!4m6!3m5!1s0x4780dfa7515a20db:0x2382039bc14163ac!8m2!3d45.1651038!4d9.6906247!16s%2Fg%2F11s2289pvf?entry=ttu&g_ep=EgoyMDI1MDMwMy4wIKXMDSoASAFQAw%3D%3D"
													target="_blank">
													via Sergio Ramelli 5
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row pt--90">
						<div className="col-lg-12">
							<div className="single-footer-one-wrapper">
								<div className="single-footer-component first">
									<div className="title-area">
										<h5 className="title">Su di noi</h5>
									</div>
									<div className="body">
										<p className="disc">
											Cartongesso, isolamento e ristrutturazioni a Codogno. Trasforma i tuoi spazi con
											cartongesso su misura.
										</p>
										{/* <div className="rts-social-style-one">
											<ul>
												<li>
													<a href="#">
														<i className="fa-brands fa-facebook-f"></i>
													</a>
												</li>
												<li>
													<a href="#">
														<i className="fa-brands fa-instagram"></i>
													</a>
												</li>
											</ul>
										</div> */}
									</div>
								</div>
								<div className="single-footer-component">
									<div className="title-area">
										<h5 className="title">Link utili</h5>
									</div>
									<div className="body">
										<div className="pages-footer">
											<ul>
												<li>
													<a href="/">
														<i className="fa-solid fa-arrow-right"></i>
														<p>Home</p>
													</a>
												</li>
												<li>
													<a href="#about">
														<i className="fa-solid fa-arrow-right"></i>
														<p>About</p>
													</a>
												</li>
												<li>
													<a href="#services">
														<i className="fa-solid fa-arrow-right"></i>
														<p>Servizi</p>
													</a>
												</li>
												{/* <li>
												<a href="#">
													<i className="fa-solid fa-arrow-right"></i>
													<p>Our Team</p>
												</a>
											</li> */}
												<li>
													<a href="#contact">
														<i className="fa-solid fa-arrow-right"></i>
														<p>Contatti</p>
													</a>
												</li>
												<li>
													<a href="https://www.iubenda.com/privacy-policy/16997403" target="_blank">
														<i className="fa-solid fa-arrow-right"></i>
														<p>Privacy Policy</p>
													</a>
												</li>
												<li>
													<a
														href="https://www.iubenda.com/privacy-policy/16997403/cookie-policy"
														target="_blank">
														<i className="fa-solid fa-arrow-right"></i>
														<p>Cookie Policy</p>
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="single-footer-component">
									<div className="title-area">
										<h5 className="title">Cosa facciamo</h5>
									</div>
									<div className="body">
										<div className="pages-footer">
											<ul>
												<li>
													<i className="fa-solid fa-arrow-right"></i>
													<p>I nostri servizi</p>
												</li>
												<li>
													<i className="fa-solid fa-arrow-right"></i>
													<p>Controsoffitti</p>
												</li>
												<li>
													<i className="fa-solid fa-arrow-right"></i>
													<p>Pareti divisorie</p>
												</li>
												<li>
													<i className="fa-solid fa-arrow-right"></i>
													<p>Contropareti</p>
												</li>
												<li>
													<i className="fa-solid fa-arrow-right"></i>
													<p>Rivestimenti speciali</p>
												</li>
												<li>
													<i className="fa-solid fa-arrow-right"></i>
													<p>Elementi architettonici in cartongesso</p>
												</li>
												<li>
													<i className="fa-solid fa-arrow-right"></i>
													<p>Isolamento e posa materiali</p>
												</li>
												<li>
													<i className="fa-solid fa-arrow-right"></i>
													<p>Lavorazioni speciali</p>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="single-footer-component last">
									<div className="title-area">
										<h5 className="title">Galleria foto</h5>
									</div>
									<div className="body">
										<div className="gallery-footer">
											<ul>
												{imagesFooter.splice(0, 10).map((element, index) => (
													<li key={"gallery-footer-" + index}>
														<a href={element.img} target="_blank">
															<img src={element.img} alt={element.alt} />
														</a>
													</li>
												))}
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="copyright-footer-one">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="wrapper">
								<p>
									Copyright {new Date().getFullYear()} TECNO C.G.E. S.A.S. DI EMILIANO CARELLI &
									C. | All Rights Reserved. | Made by{" "}
									<a href="https://www.dojoagency.it" target="_blank">
										Dojo Agency
									</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Footer;
